import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { DriverModel } from '../../../../model/driver.model';
import { RouterLink } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CompanyModel } from '../../../../model/company.model';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DriverStatusEnum } from '../../../../model/Enums/DriverStatusEnum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-driver',
  standalone: true,
  imports: [
    ButtonModule,
    TableModule,
    TooltipModule,
    InputSwitchModule,
    RouterLink,
    DividerModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    DialogModule,
    DropdownModule,
    TabViewModule,
    ConfirmDialogModule,
    ToastModule,
    IconFieldModule,
    InputIconModule,
    CommonModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-driver.component.html',
  styleUrl: './list-driver.component.css',
})
export class ListDriverComponent implements OnInit {
  ltsDriver: DriverModel[] = [];
  ltsDriverDelete: DriverModel[] = [];
  ltsDriverPendiente: DriverModel[] = [];
  ltsDriverConflicto: DriverModel[] = [];

  ltsCompany: CompanyModel[] = [];
  companySelected!: CompanyModel;
  titulo: string = 'Conductores';
  dialogEdit: boolean = false;
  formConductor = new FormGroup({
    dri_name: new FormControl('', Validators.required),
    dri_last_name: new FormControl('', Validators.required),
    dri_number_license: new FormControl('', Validators.required),
    dri_term_conditions: new FormControl(false, Validators.required),
    dri_social: new FormControl('', Validators.required),
    dri_phone: new FormControl('', Validators.required),
    dri_address: new FormControl('', Validators.required),
    dri_password: new FormControl('', Validators.required),
    dri_id: new FormControl('', Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getLtsCompany();
  }

  getListDriver(): void {
    let data = {
      dri_company: this.companySelected.com_id,
    };
    const body: JsonRequest = {
      data: JSON.stringify(data),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllDriver,
      body,
      (data) => {
        this.ltsDriver = data.data;
        this.ltsDriver.forEach((item) => {
          item.estado = item.dri_status == 1;
        });
        this.getListDriverStatus(DriverStatusEnum.Delete);
        this.getListDriverStatus(DriverStatusEnum.Pending);
        this.getListDriverStatus(DriverStatusEnum.PendingVehicleConflict);
      },
    );
  }

  getListDriverStatus(status: number): void {
    let data = { dri_status: status, dri_company: this.companySelected.com_id };
    const body: JsonRequest = {
      data: JSON.stringify(data),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetDeleteDriver,
      body,
      (data) => {
        if (status === DriverStatusEnum.Delete) {
          this.ltsDriverDelete = data.data;
          this.ltsDriverDelete.forEach((item) => {
            item.estado = item.dri_status == 1;
          });
        } else if (status === DriverStatusEnum.Pending) {
          this.ltsDriverPendiente = data.data;
          this.ltsDriverPendiente.forEach((item) => {
            item.estado = item.dri_status == 1;
          });
        } else if (status === DriverStatusEnum.PendingVehicleConflict) {
          this.ltsDriverConflicto = data.data;
        }
      },
    );
  }

  DeleteDriverPendingVehicle(event: Event, driver: DriverModel) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `¿Eliminar definitivamente a ${driver.dri_name} ${driver.dri_last_name}? Deberá registrarse de nuevo con otra placa.`,
      header: 'Eliminar conductor (conflicto de placa)',
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',
      accept: () => {
        const body: JsonRequest = {
          data: JSON.stringify({ dri_id: driver.dri_id }),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };
        this.apiService.consumirWSPost(
          properties.serviceDeleteDriverPendingVehicle,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.ltsDriverConflicto = this.ltsDriverConflicto.filter(
                (d) => d.dri_id !== driver.dri_id,
              );
              this.util.mostrarToast(
                'Conductor eliminado',
                'Se ha eliminado el conductor',
                1,
              );
            } else {
              this.util.mostrarToast(
                'Conductor eliminado',
                data.mensaje || 'Error al eliminar',
                4,
              );
            }
          },
        );
      },
      reject: () => {},
    });
  }

  getLtsCompany(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllCompanyActive,
      body,
      (data) => {
        this.ltsCompany = data.data;
      },
    );
  }

  showDialog(driver: DriverModel) {
    this.dialogEdit = true;
    this.formConductor.setValue({
      dri_name: driver.dri_name,
      dri_last_name: driver.dri_last_name,
      dri_number_license: driver.dri_number_license,
      dri_term_conditions: driver.dri_term_conditions,
      dri_social: driver.dri_social.toString(),
      dri_phone: driver.dri_phone,
      dri_address: driver.dri_address,
      dri_password: driver.dri_password,
      dri_id: driver.dri_id.toString(),
    });
  }

  save() {
    const body: JsonRequest = {
      data: JSON.stringify({
        dri_name: this.formConductor.get('dri_name')?.value,
        dri_last_name: this.formConductor.get('dri_last_name')?.value,
        dri_number_license: this.formConductor.get('dri_number_license')?.value,
        dri_term_conditions: this.formConductor.get('dri_term_conditions')
          ?.value,
        dri_social: this.formConductor.get('dri_social')?.value,
        dri_phone: this.formConductor.get('dri_phone')?.value,
        dri_address: this.formConductor.get('dri_address')?.value,
        dri_password: this.formConductor.get('dri_password')?.value,
        dri_id: this.formConductor.get('dri_id')?.value,
        dri_status: 1,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };

    this.apiService.consumirWSPost(
      properties.serviceUpdateDriver,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.util.mostrarToast(
            'Editar Conductor',
            'Se ha editado el conductor',
            1,
          );
          this.formConductor.reset();
          this.dialogEdit = false;
          this.getListDriver();
        } else {
          this.util.mostrarToast('Editar Conductor', 'Error al editar', 4);
        }
      },
    );
  }

  DeleteDriver(event: Event, driver: DriverModel) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Quieres eliminar a este conductor?',
      header: 'Eliminar Conductor',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        driver.dri_status = 0;
        const body: JsonRequest = {
          data: JSON.stringify(driver),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.apiService.consumirWSPost(
          properties.serviceDeleteDriver,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Conductor Eliminado',
                'Se ha eliminado el conductor',
                1,
              );
              this.formConductor.reset();
              this.dialogEdit = false;
              this.getListDriver();
            } else {
              this.util.mostrarToast(
                'Conductor Eliminado',
                'Error al eliminar',
                4,
              );
            }
          },
        );
      },
      reject: () => {},
    });
  }

  unlockDriver(event: Event, driver: DriverModel) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Quieres liberar a este conductor?',
      header: 'Liberar Conductor',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        driver.dri_status = 0;
        const body: JsonRequest = {
          data: JSON.stringify(driver),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.apiService.consumirWSPost(
          properties.serviceUnlockDriver,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Conductor Liberado',
                'Se ha liberado el conductor',
                1,
              );
              this.formConductor.reset();
              this.dialogEdit = false;
              this.getListDriver();
            } else {
              this.util.mostrarToast(
                'Conductor Liberado',
                'Error al liberar',
                4,
              );
            }
          },
        );
      },
      reject: () => {},
    });
  }

  ActivateDriver(event: Event, driver: DriverModel) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Desea activar a este conductor?',
      header: 'Activar Conductor',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',

      accept: () => {
        driver.dri_status = 1;
        const body: JsonRequest = {
          data: JSON.stringify(driver),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.apiService.consumirWSPost(
          properties.serviceChangeStatusDriver,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Conductor Activado',
                'Se ha Activado el conductor',
                1,
              );
              this.formConductor.reset();
              this.dialogEdit = false;
              this.getListDriverStatus(0);
            } else {
              this.util.mostrarToast(
                'Conductor Activado',
                'Error al activar',
                4,
              );
            }
          },
        );
      },
      reject: () => {},
    });
  }
}
